
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.8)), url('https://public.readdy.ai/ai/img_res/fdd6dcc80ca8287b0bdecbed122f91b6.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-left">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Transform Your Business with 
              <span className="text-emerald-600"> Expert IT Solutions</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              We help businesses navigate digital transformation, optimize technology infrastructure, and achieve sustainable growth through strategic IT consulting and innovative solutions.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                onClick={scrollToContact}
                size="lg"
                className="shadow-2xl"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-phone-line"></i>
                </div>
                Get Free Consultation
              </Button>
              <Button 
                onClick={scrollToServices}
                variant="outline"
                size="lg"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-service-line"></i>
                </div>
                Explore Services
              </Button>
            </div>
            <div className="mt-12 grid grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-600">500+</div>
                <div className="text-gray-600">Projects Completed</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-600">15+</div>
                <div className="text-gray-600">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-600">98%</div>
                <div className="text-gray-600">Client Satisfaction</div>
              </div>
            </div>
          </div>
          <div className="hidden lg:block">
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20IT%20consultant%20working%20with%20multiple%20monitors%20displaying%20network%20diagrams%2C%20cloud%20architecture%2C%20cybersecurity%20dashboards%2C%20modern%20office%20setting%20with%20green%20accent%20lighting%2C%20technology%20expert%20analyzing%20data%2C%20sophisticated%20workspace%20with%20advanced%20computing%20equipment%2C%20professional%20business%20environment&width=600&height=700&seq=hero-consultant&orientation=portrait"
              alt="IT Consultant at Work"
              className="rounded-2xl shadow-2xl object-cover w-full h-[600px] object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
